import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAdminData } from '../../../contexts/AdminDataContext';
import '../../../styles/PlayerList.css';

const PersonIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <circle cx="12" cy="12" r="12" fill="#1e293b"/>
    <circle cx="12" cy="9" r="3.5" fill="#475569"/>
    <path d="M4.5 20c0-4.142 3.358-7 7.5-7s7.5 2.858 7.5 7" stroke="#475569" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
  </svg>
);

const PlayerList = () => {
  const { allPlayers, playersLoading } = useAdminData();
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const filteredPlayers = allPlayers.filter(player => {
    if (searchQuery) {
      const query = searchQuery.toLowerCase();
      return player.username.toLowerCase().includes(query);
    }
    return true;
  });

  const handlePlayerClick = (playerId) => {
    navigate(`/admin/players/${playerId}`);
  };

  return (
    <div className="player-list-page">
      <div className="page-header">
        <h1>Players</h1>
        <Link to="/admin/players/create" className="create-button">
          Create New Player
        </Link>
      </div>

      <div className="search-box">
        <input
          type="text"
          placeholder="Search players..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input"
        />
      </div>

      {playersLoading ? (
        <div className="loading-spinner"></div>
      ) : filteredPlayers.length === 0 ? (
        <div className="no-results">No players found</div>
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Player</th>
            </tr>
          </thead>
          <tbody>
            {filteredPlayers.map(player => (
              <tr
                key={player.id}
                onClick={() => handlePlayerClick(player.id)}
                style={{ cursor: 'pointer' }}
              >
                <td className="player-cell">
                  <div className="player-list-item">
                    <div className="player-list-image-container">
                      {player.image ? (
                        <img
                          src={player.image}
                          alt={player.username}
                          className="player-list-image"
                          onError={(e) => { e.target.src = '/assets/images/placeholder.png' }}
                        />
                      ) : (
                        <PersonIcon className="player-list-icon" />
                      )}
                    </div>
                    <span className="player-username">{player.username}</span>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PlayerList;
